// extracted by mini-css-extract-plugin
export default {"container":"OurRecruitment_container__rt9Jb","cardcontainer":"OurRecruitment_cardcontainer__aYtPT","erroralert":"OurRecruitment_erroralert__eZEim"};